import { render, staticRenderFns } from "./TranslationDetails.vue?vue&type=template&id=227f73de"
import script from "./TranslationDetails.vue?vue&type=script&lang=js"
export * from "./TranslationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports